import React, { useState, useEffect } from 'react';
import './App.css';
import Plot from 'react-plotly.js';
import * as greeks from 'greeks';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import Footer from './Footer';
const { Deta } = require('deta');

function calculateGammaExposure(symbolData, lastPrice, roundAmount1) {
  const gammaExposure = {};
  // Loop through the greeks data for each strike
  for (const contract in symbolData.value) {
    const greeks = symbolData.value[contract];
    const call_gamma = greeks[0];
    const call_open_interest = greeks[2];
    const put_gamma = greeks[3];
    const put_open_interest = greeks[5];
    const strike = greeks[6];

    // Perform further calculations or operations with the greeks data for each strike
    const callGex = (call_gamma < 0.0001 || isNaN(call_gamma) || call_open_interest < 1)
      ? 0
      : parseFloat(call_gamma * call_open_interest);

    //console.log("callGex: ", callGex)
    const putGex = (put_gamma < 0.0001 || isNaN(put_gamma) || put_open_interest < 1)
      ? 0
      : parseFloat(put_gamma * put_open_interest);
    //console.log("putGex: ", putGex)

    gammaExposure[strike] = ((callGex - putGex) * lastPrice) / roundAmount1;
  }

  // Print the gamma exposure for each strike
  // for (const strike in gammaExposure) {
  //   const exposure = gammaExposure[strike];
  //   //console.log(`Strike: ${strike}, Gamma Exposure: ${exposure}`);
  // } 

  return gammaExposure;
}

const App = () => {
  const [symbolData, setSymbolData] = useState([]);
  const [spyLast, setSpyLast] = useState(0);
  const [tableNameDate, setTableNameDate] = useState(0);
  const [strikeData, setStrikeData] = useState({});
  const [gammaExposure, setGammaExposure] = useState({});
  const [adjustedGammaExposure, setAdjustedGammaExposure] = useState({});
  const [sliderValue, setSliderValue] = useState(spyLast);
  const [largestPositiveGammaStrike, setLargestPositiveGammaStrike] = useState("");
  const [largestNegativeGammaStrike, setLargestNegativeGammaStrike] = useState("");
  const [totalGammaExposure, setTotalGammaExposure] = useState(0);

  const [symbolData2, setSymbolData2] = useState([]);
  const [qqqLast, setQQQLast] = useState(0);
  const [symbolDataSPX, setSymbolDataSPX] = useState([]);
  const [SPXLast, setSPXLast] = useState(0);
  const [symbolDataNDX, setSymbolDataNDX] = useState([]);
  const [NDXLast, setNDXLast] = useState(0);

  const [strikeData2, setStrikeData2] = useState({});
  const [gammaExposure2, setGammaExposure2] = useState({});
  const [adjustedGammaExposure2, setAdjustedGammaExposure2] = useState({});
  const [sliderValue2, setSliderValue2] = useState(qqqLast);
  const [sliderValue3, setSliderValue3] = useState(SPXLast);
  const [sliderValue4, setSliderValue4] = useState(NDXLast);

  const [largestPositiveGammaStrike2, setLargestPositiveGammaStrike2] = useState("");
  const [largestNegativeGammaStrike2, setLargestNegativeGammaStrike2] = useState("");
  const [totalGammaExposure2, setTotalGammaExposure2] = useState(0);
  const [updateTime, setUpdateTime] = useState(0);

  const [sliderChange, setSliderChange] = useState(0);

  const [adjustedGammaExposure3, setAdjustedGammaExposure3] = useState({});
  const [largestPositiveGammaStrike3, setLargestPositiveGammaStrike3] = useState("");
  const [largestNegativeGammaStrike3, setLargestNegativeGammaStrike3] = useState("");
  const [totalGammaExposure3, setTotalGammaExposure3] = useState(0);

  const [adjustedGammaExposure4, setAdjustedGammaExposure4] = useState({});
  const [largestPositiveGammaStrike4, setLargestPositiveGammaStrike4] = useState("");
  const [largestNegativeGammaStrike4, setLargestNegativeGammaStrike4] = useState("");
  const [totalGammaExposure4, setTotalGammaExposure4] = useState(0);

  const [layout, setLayout] = useState({});
  const [layout2, setLayout2] = useState({});
  const [layout3, setLayout3] = useState({});
  const [layout4, setLayout4] = useState({});
  //const [maxAbsGex, setMaxAbsGex] = useState(0);
  //const [xAxisRange, setXAxisRange] = useState([]);

  const calculateCircleSize = (gexValue, maxAbsGex) => {
    // Adjust this calculation based on your data scale and desired visual effect
    const baseSize = Math.sqrt(Math.abs(gexValue)) * .2;
    //const baseSize = Math.abs(gexValue) * .03;
    //console.log("max_width_base: ", baseSize)
    return baseSize;
  };

  const calculateYAxisRange = (gammaExposure) => {
    const values = Object.values(gammaExposure);
    const maxPositive = Math.max(0, ...values);
    const minNegative = Math.min(0, ...values);
    const buffer = (maxPositive - minNegative) * 0.2; // 10% buffer
    return [minNegative - buffer, maxPositive + buffer];
  };

  async function handleSliderChange(value) {
    const change = parseFloat(value);
    //console.log("change: ", change)
    const price = change + Math.round(spyLast)
    //console.log("price: ", price)
    setSliderValue(price);

    const price2 = change + Math.round(qqqLast);
    //console.log("price2: ", price2)
    setSliderValue2(price2);
    setSliderChange(change);

    // SPX
    const price3 = change*10 + Math.round(SPXLast);
    setSliderValue3(price3);

    // NDX
    const price4 = change*40 + Math.round(NDXLast);
    setSliderValue4(price4);

    // Calculate adjusted gamma exposure
    let calculatedAdjustedGammaExposure = {};
    for (let contract in symbolData.value) {
      const greeks_list = symbolData.value[contract];
      const call_gamma = greeks_list[0];
      const call_volatility = greeks_list[1];
      const call_open_interest = greeks_list[2];
      const put_gamma = greeks_list[3];
      const put_volatility = greeks_list[4];
      const put_open_interest = greeks_list[5];
      const strike = greeks_list[6];

      //const callOption = symbolData[strike].call;
      //console.log("callOption: ", callOption)
      //const putOption = strikeData[strike].put;

      // Calculate call option Greeks  (price, strike, time, iv, rate)
      //const callGreeks = greeks.getGamma(410, 410, 1/365, .1, 0); 
      //console.log("callGreeks: ", callGreeks);
  
      // getGamma(price, strike, time, iv, rate)
      // getGamma(s, k, t, v, r)
      // Calculate call option Greeks
      const callGamma1 = greeks.getGamma(
        price,
        strike,
        (1/365),
        parseFloat(call_volatility/100),
        0
      );
  
      // Calculate put option Greeks
      const putGamma1 = greeks.getGamma(
        price,
        strike,
        (1/365),
        parseFloat(put_volatility/100),
        0
      );
  
      const callGex =
        call_gamma < 0.0001 ||
        call_gamma === 'NaN' ||
        call_open_interest < 1
          ? 0
          : callGamma1 * call_open_interest;
      const putGex =
        put_gamma < 0.0001 ||
        put_gamma === 'NaN' ||
        put_open_interest < 1
          ? 0
          : putGamma1 * put_open_interest;
  
      calculatedAdjustedGammaExposure[strike] =
        ((callGex - putGex) * price) / 10000;
    }
    setAdjustedGammaExposure(calculatedAdjustedGammaExposure);

    const largestPositiveGammaStrike = Object.keys(calculatedAdjustedGammaExposure).reduce((max, strike) => {
      return calculatedAdjustedGammaExposure[strike] > calculatedAdjustedGammaExposure[max] ? strike : max;
    });
    setLargestPositiveGammaStrike(largestPositiveGammaStrike);
    
    const largestNegativeGammaStrike = Object.keys(calculatedAdjustedGammaExposure).reduce((min, strike) => {
      return calculatedAdjustedGammaExposure[strike] < calculatedAdjustedGammaExposure[min] ? strike : min;
    });
    setLargestNegativeGammaStrike(largestNegativeGammaStrike);

    const totalGammaExposure = Object.values(calculatedAdjustedGammaExposure).reduce((sum, value) => sum + value, 0);
    setTotalGammaExposure(totalGammaExposure);

    // Calculate adjusted gamma exposure2
    let calculatedAdjustedGammaExposure2 = {};
    for (let contract in symbolData2.value) {
      const greeks_list = symbolData2.value[contract];
      const call_gamma = greeks_list[0];
      const call_volatility = greeks_list[1];
      const call_open_interest = greeks_list[2];
      const put_gamma = greeks_list[3];
      const put_volatility = greeks_list[4];
      const put_open_interest = greeks_list[5];
      const strike = greeks_list[6];

      const callGamma2 = greeks.getGamma(
        price2,
        strike,
        (1/365),
        parseFloat(call_volatility/100),
        0
      );
  
      // Calculate put option Greeks
      const putGamma2 = greeks.getGamma(
        price2,
        strike,
        (1/365),
        parseFloat(put_volatility/100),
        0
      );
  
      const callGex =
        call_gamma < 0.0001 ||
        call_gamma === 'NaN' ||
        call_open_interest < 1
          ? 0
          : callGamma2 * call_open_interest;
      const putGex =
        put_gamma < 0.0001 ||
        put_gamma === 'NaN' ||
        put_open_interest < 1
          ? 0
          : putGamma2 * put_open_interest;
  
  
      calculatedAdjustedGammaExposure2[strike] =
        ((callGex - putGex) * price2) / 10000;
    }
    setAdjustedGammaExposure2(calculatedAdjustedGammaExposure2);

    const largestPositiveGammaStrike2 = Object.keys(calculatedAdjustedGammaExposure2).reduce((max, strike) => {
      return calculatedAdjustedGammaExposure2[strike] > calculatedAdjustedGammaExposure2[max] ? strike : max;
    });
    setLargestPositiveGammaStrike2(largestPositiveGammaStrike2);
    
    const largestNegativeGammaStrike2 = Object.keys(calculatedAdjustedGammaExposure2).reduce((min, strike) => {
      return calculatedAdjustedGammaExposure2[strike] < calculatedAdjustedGammaExposure2[min] ? strike : min;
    });
    setLargestNegativeGammaStrike2(largestNegativeGammaStrike2);

    const totalGammaExposure2 = Object.values(calculatedAdjustedGammaExposure2).reduce((sum, value) => sum + value, 0);
    setTotalGammaExposure2(totalGammaExposure2);

    // SPX
    // Calculate adjusted gamma exposure3
    let calculatedAdjustedGammaExposure3 = {};
    for (let contract in symbolDataSPX.value) {
      const greeks_list = symbolDataSPX.value[contract];
      const call_gamma = greeks_list[0];
      const call_volatility = greeks_list[1];
      const call_open_interest = greeks_list[2];
      const put_gamma = greeks_list[3];
      const put_volatility = greeks_list[4];
      const put_open_interest = greeks_list[5];
      const strike = greeks_list[6];

      const callGamma3 = greeks.getGamma(
        price3,
        strike,
        (1/365),
        parseFloat(call_volatility/100),
        0
      );
  
      // Calculate put option Greeks
      const putGamma3 = greeks.getGamma(
        price3,
        strike,
        (1/365),
        parseFloat(put_volatility/100),
        0
      );
  
      const callGex =
        call_gamma < 0.0001 ||
        call_gamma === 'NaN' ||
        call_open_interest < 1
          ? 0
          : callGamma3 * call_open_interest;
      const putGex =
        put_gamma < 0.0001 ||
        put_gamma === 'NaN' ||
        put_open_interest < 1
          ? 0
          : putGamma3 * put_open_interest;
  
  
      calculatedAdjustedGammaExposure3[strike] =
        ((callGex - putGex) * price3) / 1000;
    }

    setAdjustedGammaExposure3(calculatedAdjustedGammaExposure3); 
    const largestPositiveGammaStrike3 = Object.keys(calculatedAdjustedGammaExposure3).reduce((max, strike) => {
      return calculatedAdjustedGammaExposure3[strike] > calculatedAdjustedGammaExposure3[max] ? strike : max;
    });
    setLargestPositiveGammaStrike3(largestPositiveGammaStrike3);

    const largestNegativeGammaStrike3 = Object.keys(calculatedAdjustedGammaExposure3).reduce((min, strike) => {
      return calculatedAdjustedGammaExposure3[strike] < calculatedAdjustedGammaExposure3[min] ? strike : min;
    });

    setLargestNegativeGammaStrike3(largestNegativeGammaStrike3);

    const totalGammaExposure3 = Object.values(calculatedAdjustedGammaExposure3).reduce((sum, value) => sum + value, 0);
    setTotalGammaExposure3(totalGammaExposure3);


    // NDX
    // Calculate adjusted gamma exposure4
    let calculatedAdjustedGammaExposure4 = {};
    for (let contract in symbolDataNDX.value) {
      const greeks_list = symbolDataNDX.value[contract];
      const call_gamma = greeks_list[0];
      const call_volatility = greeks_list[1];
      const call_open_interest = greeks_list[2];
      const put_gamma = greeks_list[3];
      const put_volatility = greeks_list[4];
      const put_open_interest = greeks_list[5];
      const strike = greeks_list[6];

      const callGamma4 = greeks.getGamma(
        price4,
        strike,
        (1/365),
        parseFloat(call_volatility/100),
        0
      );
  
      // Calculate put option Greeks
      const putGamma4 = greeks.getGamma(
        price4,
        strike,
        (1/365),
        parseFloat(put_volatility/100),
        0
      );
  
      const callGex =
        call_gamma < 0.0001 ||
        call_gamma === 'NaN' ||
        call_open_interest < 1
          ? 0
          : callGamma4 * call_open_interest;
      const putGex =
        put_gamma < 0.0001 ||
        put_gamma === 'NaN' ||
        put_open_interest < 1
          ? 0
          : putGamma4 * put_open_interest;
  
      // ndx unique here. 
      calculatedAdjustedGammaExposure4[strike] =
        ((callGex - putGex) * price4) / 250;
    }

    setAdjustedGammaExposure4(calculatedAdjustedGammaExposure4);
    const largestPositiveGammaStrike4 = Object.keys(calculatedAdjustedGammaExposure4).reduce((max, strike) => {
      return calculatedAdjustedGammaExposure4[strike] > calculatedAdjustedGammaExposure4[max] ? strike : max;
    });
    setLargestPositiveGammaStrike4(largestPositiveGammaStrike4);

    const largestNegativeGammaStrike4 = Object.keys(calculatedAdjustedGammaExposure4).reduce((min, strike) => {
      return calculatedAdjustedGammaExposure4[strike] < calculatedAdjustedGammaExposure4[min] ? strike : min;
    });

    setLargestNegativeGammaStrike4(largestNegativeGammaStrike4);

    const totalGammaExposure4 = Object.values(calculatedAdjustedGammaExposure4).reduce((sum, value) => sum + value, 0);
    setTotalGammaExposure4(totalGammaExposure4);

    //const maxAbsGex = Math.max(...Object.values(calculatedAdjustedGammaExposure).map(Math.abs));
    //setMaxAbsGex(maxAbsGex)

    const strikes = Object.keys(adjustedGammaExposure).map(Number);
    const minStrike = Math.min(...strikes);
    const maxStrike = Math.max(...strikes);
    //const range = maxStrike - minStrike;
    //const padding = range * 0.1; // Add 10% padding on each side
    const newXAxisRange = [minStrike - .5, maxStrike + .5];

    const yAxisRange = calculateYAxisRange(adjustedGammaExposure);

    // Create initial layout
    const adjustedLayout = {
      title: `SPY<br>${sliderValue}`,
      
      xaxis: { 
        title: 'Strike',
        range: newXAxisRange,
        fixedrange: true
      },
      yaxis: { 
        title: 'SPY Gamma Exposure',
        range: yAxisRange,
        fixedrange: true
      },
      plot_bgcolor: '#222',
      paper_bgcolor: '#222',
      font: { color: 'white' },
      width: isMobile() ? Math.min(window.innerWidth * 0.9, 800) : 800,
      height: 500, // Set the height of the graph
      annotations: [
        {
          xref: 'paper',
          yref: 'paper',
          x: 0,
          xanchor: 'right',
          y: 1,
          yanchor: 'bottom',
          text: ` ${updateTime}`,
          font: {
            family: 'Arial',
            size: 14,
            color: 'white',
          },
          showarrow: false,
        },
        {
          x: largestPositiveGammaStrike,
          y: adjustedGammaExposure[largestPositiveGammaStrike],
          xanchor: 'center',
          yanchor: 'bottom',
          text: `${largestPositiveGammaStrike}`,
          font: {
            family: 'Arial',
            size: 14,
            color: 'green',
          },
          showarrow: true,
          arrowhead: 1,
          ax: 0,
          ay: -30,
        },
        {
          x: largestNegativeGammaStrike,
          y: adjustedGammaExposure[largestNegativeGammaStrike],
          xanchor: 'center',
          yanchor: 'top',
          text: `${largestNegativeGammaStrike}`,
          font: {
            family: 'Arial',
            size: 14,
            color: 'red',
          },
          showarrow: true,
          arrowhead: 1,
          ax: 0,
          ay: 30,
        },
        {
          xref: 'paper',
          yref: 'paper',
          x: 1,
          xanchor: 'right',
          y: 1,
          yanchor: 'bottom',
          text: `Total: ${totalGammaExposure.toFixed(0)}M`,
          font: {
            family: 'Arial',
            size: 14,
            color: 'white',
          },
          showarrow: false,
        },
      ],
      shapes: [
        {
          type: 'circle',
          xref: 'x',
          yref: 'y',
          x0: parseFloat(largestPositiveGammaStrike) - calculateCircleSize(adjustedGammaExposure[largestPositiveGammaStrike]),
          y0: -Math.max(Math.abs(adjustedGammaExposure[largestPositiveGammaStrike]), Math.abs(adjustedGammaExposure[largestNegativeGammaStrike])),
          x1: parseFloat(largestPositiveGammaStrike) + calculateCircleSize(adjustedGammaExposure[largestPositiveGammaStrike]),
          y1: Math.max(Math.abs(adjustedGammaExposure[largestPositiveGammaStrike]), Math.abs(adjustedGammaExposure[largestNegativeGammaStrike])),
          fillcolor: 'green',
          opacity: 0.3,
          line: { color: 'green', width: 2 }
        },
        {
          type: 'circle',
          xref: 'x',
          yref: 'y',
          x0: parseFloat(largestNegativeGammaStrike) - calculateCircleSize(adjustedGammaExposure[largestNegativeGammaStrike]),
          y0: -Math.abs(adjustedGammaExposure[largestNegativeGammaStrike]),
          x1: parseFloat(largestNegativeGammaStrike) + calculateCircleSize(adjustedGammaExposure[largestNegativeGammaStrike]),
          y1: Math.abs(adjustedGammaExposure[largestNegativeGammaStrike]),
          fillcolor: 'red',
          opacity: 0.3,
          line: { color: 'red', width: 2 }
        },
        {
          type: 'line',
          xref: 'x',
          x0: sliderValue,
          x1: sliderValue,
          yref: 'paper',
          y0: 0,
          y1: 1,
          yanchor: 'bottom',
          line: {
            color: 'white',
            width: 2,
          },
        },
      ],

    };
    setLayout(adjustedLayout)

    const strikes2 = Object.keys(adjustedGammaExposure2).map(Number);
    const minStrike2 = Math.min(...strikes2);
    const maxStrike2 = Math.max(...strikes2);
    const newXAxisRange2 = [minStrike2 - .5, maxStrike2 + .5];
    const yAxisRange2 = calculateYAxisRange(adjustedGammaExposure2);

    const adjustedLayout2 = {
      title: `QQQ<br>${sliderValue2}`,
      
      xaxis: { 
        title: 'Strike',
        range: newXAxisRange2,
        fixedrange: true
      },
      yaxis: { 
        title: 'QQQ Gamma Exposure',
        range: yAxisRange2,
        fixedrange: true
      },
      plot_bgcolor: '#222',
      paper_bgcolor: '#222',
      font: { color: 'white' },
      width: isMobile() ? Math.min(window.innerWidth * 0.9, 800) : 800,
      height: 500, // Set the height of the graph
      annotations: [
        {
          xref: 'paper',
          yref: 'paper',
          x: 0,
          xanchor: 'right',
          y: 1,
          yanchor: 'bottom',
          text: ` ${tableNameDate}`,
          font: {
            family: 'Arial',
            size: 14,
            color: 'white',
          },
          showarrow: false,
        },
        {
          x: largestPositiveGammaStrike2,
          y: adjustedGammaExposure2[largestPositiveGammaStrike2],
          xanchor: 'center',
          yanchor: 'bottom',
          text: `${largestPositiveGammaStrike2}`,
          font: {
            family: 'Arial',
            size: 14,
            color: 'green',
          },
          showarrow: true,
          arrowhead: 1,
          ax: 0,
          ay: -30,
        },
        {
          x: largestNegativeGammaStrike2,
          y: adjustedGammaExposure2[largestNegativeGammaStrike2],
          xanchor: 'center',
          yanchor: 'top',
          text: `${largestNegativeGammaStrike2}`,
          font: {
            family: 'Arial',
            size: 14,
            color: 'red',
          },
          showarrow: true,
          arrowhead: 1,
          ax: 0,
          ay: 30,
        },
        {
          xref: 'paper',
          yref: 'paper',
          x: 1,
          xanchor: 'right',
          y: 1,
          yanchor: 'bottom',
          text: `Total: ${totalGammaExposure2.toFixed(0)}M`,
          font: {
            family: 'Arial',
            size: 14,
            color: 'white',
          },
          showarrow: false,
        },
      ],
      shapes: [
        {
          type: 'circle',
          xref: 'x',
          yref: 'y',
          x0: parseFloat(largestPositiveGammaStrike2) - calculateCircleSize(adjustedGammaExposure2[largestPositiveGammaStrike2]),
          y0: -Math.max(Math.abs(adjustedGammaExposure2[largestPositiveGammaStrike2]), Math.abs(adjustedGammaExposure2[largestNegativeGammaStrike2])),
          x1: parseFloat(largestPositiveGammaStrike2) + calculateCircleSize(adjustedGammaExposure2[largestPositiveGammaStrike2]),
          y1: Math.max(Math.abs(adjustedGammaExposure2[largestPositiveGammaStrike2]), Math.abs(adjustedGammaExposure2[largestNegativeGammaStrike2])),
          fillcolor: 'green',
          opacity: 0.3,
          line: { color: 'green', width: 2 }
        },
        {
          type: 'circle',
          xref: 'x',
          yref: 'y',
          x0: parseFloat(largestNegativeGammaStrike2) - calculateCircleSize(adjustedGammaExposure2[largestNegativeGammaStrike2]),
          y0: -Math.abs(adjustedGammaExposure2[largestNegativeGammaStrike2]),
          x1: parseFloat(largestNegativeGammaStrike2) + calculateCircleSize(adjustedGammaExposure2[largestNegativeGammaStrike2]),
          y1: Math.abs(adjustedGammaExposure2[largestNegativeGammaStrike2]),
          fillcolor: 'red',
          opacity: 0.3,
          line: { color: 'red', width: 2 }
        },
        {
          type: 'line',
          xref: 'x',
          x0: sliderValue2,
          x1: sliderValue2,
          yref: 'paper',
          y0: 0,
          y1: 1,
          yanchor: 'bottom',
          line: {
            color: 'white',
            width: 2,
          },
        },
      ],

    };
    setLayout2(adjustedLayout2)

    const strikes3 = Object.keys(adjustedGammaExposure3).map(Number);
    const minStrike3 = Math.min(...strikes3);
    const maxStrike3 = Math.max(...strikes3);
    const newXAxisRange3 = [minStrike3 - 2.5, maxStrike3 + 2.5];
    const yAxisRange3 = calculateYAxisRange(adjustedGammaExposure3);

    const adjustedLayout3 = {
      title: `SPX<br>${sliderValue3}`,
      
      xaxis: { 
        title: 'Strike',
        range: newXAxisRange3,
        fixedrange: true
      },
      yaxis: { 
        title: 'SPX Gamma Exposure',
        range: yAxisRange3,
        fixedrange: true
      },
      plot_bgcolor: '#222',
      paper_bgcolor: '#222',
      font: { color: 'white' },
      width: isMobile() ? Math.min(window.innerWidth * 0.9, 800) : 800,
      height: 500, // Set the height of the graph
      annotations: [
        {
          xref: 'paper',
          yref: 'paper',
          x: 0,
          xanchor: 'right',
          y: 1,
          yanchor: 'bottom',
          text: ` ${""}`,
          font: {
            family: 'Arial',
            size: 14,
            color: 'white',
          },
          showarrow: false,
        },
        {
          x: largestPositiveGammaStrike3,
          y: adjustedGammaExposure3[largestPositiveGammaStrike3],
          xanchor: 'center',
          yanchor: 'bottom',
          text: `${largestPositiveGammaStrike3}`,
          font: {
            family: 'Arial',
            size: 14,
            color: 'green',
          },
          showarrow: true,
          arrowhead: 1,
          ax: 0,
          ay: -30,
        },
        {
          x: largestNegativeGammaStrike3,
          y: adjustedGammaExposure3[largestNegativeGammaStrike3],
          xanchor: 'center',
          yanchor: 'top',
          text: `${largestNegativeGammaStrike3}`,
          font: {
            family: 'Arial',
            size: 14,
            color: 'red',
          },
          showarrow: true,
          arrowhead: 1,
          ax: 0,
          ay: 30,
        },
        {
          xref: 'paper',
          yref: 'paper',
          x: 1,
          xanchor: 'right',
          y: 1,
          yanchor: 'bottom',
          text: `Total: ${totalGammaExposure3.toFixed(0)}M`,
          font: {
            family: 'Arial',
            size: 14,
            color: 'white',
          },
          showarrow: false,
        },
      ],
      shapes: [
        {
          type: 'circle',
          xref: 'x',
          yref: 'y',
          x0: parseFloat(largestPositiveGammaStrike3) - (5*calculateCircleSize(adjustedGammaExposure3[largestPositiveGammaStrike3])),
          y0: -Math.max(Math.abs(adjustedGammaExposure3[largestPositiveGammaStrike3]), Math.abs(adjustedGammaExposure3[largestNegativeGammaStrike3])),
          x1: parseFloat(largestPositiveGammaStrike3) + (5*calculateCircleSize(adjustedGammaExposure3[largestPositiveGammaStrike3])),
          y1: Math.max(Math.abs(adjustedGammaExposure3[largestPositiveGammaStrike3]), Math.abs(adjustedGammaExposure3[largestNegativeGammaStrike3])),
          fillcolor: 'green',
          opacity: 0.3,
          line: { color: 'green', width: 2 }
        },
        {
          type: 'circle',
          xref: 'x',
          yref: 'y',
          x0: parseFloat(largestNegativeGammaStrike3) - (5*calculateCircleSize(adjustedGammaExposure3[largestNegativeGammaStrike3])),
          y0: -Math.abs(adjustedGammaExposure3[largestNegativeGammaStrike3]),
          x1: parseFloat(largestNegativeGammaStrike3) + (5*calculateCircleSize(adjustedGammaExposure3[largestNegativeGammaStrike3])),
          y1: Math.abs(adjustedGammaExposure3[largestNegativeGammaStrike3]),
          fillcolor: 'red',
          opacity: 0.3,
          line: { color: 'red', width: 2 }
        },
        {
          type: 'line',
          xref: 'x',
          x0: sliderValue3,
          x1: sliderValue3,
          yref: 'paper',
          y0: 0,
          y1: 1,
          yanchor: 'bottom',
          line: {
            color: 'white',
            width: 2,
          },
        },
      ],

    };
    setLayout3(adjustedLayout3)

    const strikes4 = Object.keys(adjustedGammaExposure4).map(Number);
    const minStrike4 = Math.min(...strikes4);
    const maxStrike4 = Math.max(...strikes4);
    const newXAxisRange4 = [minStrike4 -10, maxStrike4 + 10];
    const yAxisRange4 = calculateYAxisRange(adjustedGammaExposure4);
    
    // Create initial layout
    const adjustedLayout4 = {
      title: `NDX<br>${sliderValue4}`,
      
      xaxis: { 
        title: 'Strike',
        range: newXAxisRange4,
        fixedrange: true
      },
      yaxis: { 
        title: 'NDX Gamma Exposure',
        range: yAxisRange4,
        fixedrange: true
      },
      plot_bgcolor: '#222',
      paper_bgcolor: '#222',
      font: { color: 'white' },
      width: isMobile() ? Math.min(window.innerWidth * 0.9, 800) : 800,
      height: 500, // Set the height of the graph
      annotations: [
        {
          xref: 'paper',
          yref: 'paper',
          x: 0,
          xanchor: 'right',
          y: 1,
          yanchor: 'bottom',
          text: ` ${""}`,
          font: {
            family: 'Arial',
            size: 14,
            color: 'white',
          },
          showarrow: false,
        },
        {
          x: largestPositiveGammaStrike4,
          y: adjustedGammaExposure4[largestPositiveGammaStrike4],
          xanchor: 'center',
          yanchor: 'bottom',
          text: `${largestPositiveGammaStrike4}`,
          font: {
            family: 'Arial',
            size: 14,
            color: 'green',
          },
          showarrow: true,
          arrowhead: 1,
          ax: 0,
          ay: -30,
        },
        {
          x: largestNegativeGammaStrike4,
          y: adjustedGammaExposure4[largestNegativeGammaStrike4],
          xanchor: 'center',
          yanchor: 'top',
          text: `${largestNegativeGammaStrike4}`,
          font: {
            family: 'Arial',
            size: 14,
            color: 'red',
          },
          showarrow: true,
          arrowhead: 1,
          ax: 0,
          ay: 30,
        },
        {
          xref: 'paper',
          yref: 'paper',
          x: 1,
          xanchor: 'right',
          y: 1,
          yanchor: 'bottom',
          text: `Total: ${totalGammaExposure4.toFixed(0)}M`,
          font: {
            family: 'Arial',
            size: 14,
            color: 'white',
          },
          showarrow: false,
        },
      ],
      shapes: [
        {
          type: 'circle',
          xref: 'x',
          yref: 'y',
          x0: parseFloat(largestPositiveGammaStrike4) - (20*calculateCircleSize(adjustedGammaExposure4[largestPositiveGammaStrike4])),
          y0: -Math.max(Math.abs(adjustedGammaExposure4[largestPositiveGammaStrike4]), Math.abs(adjustedGammaExposure4[largestNegativeGammaStrike4])),
          x1: parseFloat(largestPositiveGammaStrike4) + (20*calculateCircleSize(adjustedGammaExposure4[largestPositiveGammaStrike4])),
          y1: Math.max(Math.abs(adjustedGammaExposure4[largestPositiveGammaStrike4]), Math.abs(adjustedGammaExposure4[largestNegativeGammaStrike4])),
          fillcolor: 'green',
          opacity: 0.3,
          line: { color: 'green', width: 2 }
        },
        {
          type: 'circle',
          xref: 'x',
          yref: 'y',
          x0: parseFloat(largestNegativeGammaStrike4) - (20*calculateCircleSize(adjustedGammaExposure4[largestNegativeGammaStrike4])),
          y0: -Math.abs(adjustedGammaExposure4[largestNegativeGammaStrike4]),
          x1: parseFloat(largestNegativeGammaStrike4) + (20*calculateCircleSize(adjustedGammaExposure4[largestNegativeGammaStrike4])),
          y1: Math.abs(adjustedGammaExposure4[largestNegativeGammaStrike4]),
          fillcolor: 'red',
          opacity: 0.3,
          line: { color: 'red', width: 2 }
        },
        {
          type: 'line',
          xref: 'x',
          x0: sliderValue4,
          x1: sliderValue4,
          yref: 'paper',
          y0: 0,
          y1: 1,
          yanchor: 'bottom',
          line: {
            color: 'white',
            width: 2,
          },
        },
      ],

    };
    setLayout4(adjustedLayout4)

  };


  // Load cache from localStorage initially or set to {}
  const initialCache = JSON.parse(localStorage.getItem('apiCache')) || {};
  let cache = initialCache;
  //console.log("Initial cache: ", cache);

  useEffect(() => {

    const fetchData = async () => {
      const cacheKey = 'apiData';
  
      // Check and use cache
      if (cache[cacheKey]) {
        //console.log("cache[cacheKey]: ", cache[cacheKey]);
        const currentTime = Date.now();
        const cachedTime = cache[cacheKey].time;
  
        if (currentTime - cachedTime < 5 * 60 * 1000) {
          //console.log("Using cached data:", cache[cacheKey].data);
          return cache[cacheKey].data;
        }
      }
  
  
      // Fetch the data from the API
      const data = await Deta(process.env.REACT_APP_DB).Base('2187_Base').fetch();
      //console.log("Fetched data from API:", data);
  
      // Update cache with new data
      cache[cacheKey] = {
        data: data,
        time: Date.now()
      };
  
      // Save updated cache to localStorage
      localStorage.setItem('apiCache', JSON.stringify(cache));
  
      return data;
    };
    const getData = async () => {

      const data = await fetchData();

      const items = data.items;

      const ndxData = items[0];
      const ndxPrice = items[1].value.last_price;

      const qqqData = items[2];
      const qqqPrice = items[3].value.last_price;

      const spxData = items[4];
      const spxPrice = items[5].value.last_price;

      const spyData = items[7];
      const spyPrice = items[8].value.last_price;
      const latestUpdate = items[8].value.last_update;
      
      setSymbolData(spyData);
      setSpyLast(spyPrice);
      setSliderValue(spyPrice.toFixed(2));

      setSymbolDataSPX(spxData);
      setSPXLast(spxPrice);
      setSliderValue3(spxPrice.toFixed(0));

      setSymbolData2(qqqData);
      setQQQLast(qqqPrice);
      setSliderValue2(qqqPrice.toFixed(2));

      setSymbolDataNDX(ndxData);
      setNDXLast(ndxPrice);
      setSliderValue4(ndxPrice.toFixed(0));

      const date1 = new Date(latestUpdate[0]*1000);
      //console.log("date1: ", date1);


      // Specify the time zone as 'America/New_York' (Eastern Time Zone)
      const timeZone = 'America/New_York';

      // Options for formatting the time
      const options = {
        hour: '2-digit',
        minute: '2-digit',
        timeZone: timeZone
      };

      // Convert the date to the desired format and set timezone as EST
      const formattedTime = date1.toLocaleString('en-US', options);
      console.log("formattedTime: ", formattedTime);

      function convertEpochToDateString(epoch) {
        // Create a new Date object
        const date = new Date(epoch * 1000); // Convert epoch time to milliseconds
      
        // Get the day, month, and year
        const day = date.getDate().toString().padStart(2, '0'); // Add leading zero if necessary
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Add leading zero if necessary
        const year = date.getFullYear().toString().slice(-2); // Get last two digits of the year
      
        // Return the formatted date string
        return `${month}-${day}-${year}`;
      }
      
      // Usage example
      const epochTime = latestUpdate[0]; // Replace this with your epoch time
      const dateString = convertEpochToDateString(epochTime);
      //console.log("dateString: " + dateString); // Output: 03-07-21

      setTableNameDate(dateString);

      setUpdateTime(formattedTime)

      // Calculate gamma exposure for each strike
      const calculatedGammaExposure = calculateGammaExposure(spyData, spyPrice, 10000);
      // console.log("calculatedGammaExposure: ", calculatedGammaExposure)
      setAdjustedGammaExposure(calculatedGammaExposure);

      const largestPositiveGammaStrike = Object.keys(calculatedGammaExposure).reduce((max, strike) => {
        return calculatedGammaExposure[strike] > calculatedGammaExposure[max] ? strike : max;
      }, Object.keys(calculatedGammaExposure)[0]);

      const largestNegativeGammaStrike = Object.keys(calculatedGammaExposure).reduce((min, strike) => {
        return calculatedGammaExposure[strike] < calculatedGammaExposure[min] ? strike : min;
      }, Object.keys(calculatedGammaExposure)[0]);

      const totalGammaExposure = Object.values(calculatedGammaExposure).reduce((sum, value) => sum + value, 0);
      setTotalGammaExposure(totalGammaExposure);
  
      // Calculate gamma exposure for each strike
      const calculatedGammaExposure2 = calculateGammaExposure(qqqData, qqqPrice, 10000);
      setAdjustedGammaExposure2(calculatedGammaExposure2);

      const largestPositiveGammaStrike2 = Object.keys(calculatedGammaExposure2).reduce((max, strike) => {
        return calculatedGammaExposure2[strike] > calculatedGammaExposure2[max] ? strike : max;
      }, Object.keys(calculatedGammaExposure2)[0]);
      setLargestPositiveGammaStrike2(largestPositiveGammaStrike2);
      
      const largestNegativeGammaStrike2 = Object.keys(calculatedGammaExposure2).reduce((min, strike) => {
        return calculatedGammaExposure2[strike] < calculatedGammaExposure2[min] ? strike : min;
      }, Object.keys(calculatedGammaExposure2)[0]);
      setLargestNegativeGammaStrike2(largestNegativeGammaStrike2);

      const totalGammaExposure2 = Object.values(calculatedGammaExposure2).reduce((sum, value) => sum + value, 0);
      setTotalGammaExposure2(totalGammaExposure2);

      const calculatedGammaExposure3 = calculateGammaExposure(spxData, spxPrice, 1000);
      setAdjustedGammaExposure3(calculatedGammaExposure3);

      const largestPositiveGammaStrike3 = Object.keys(calculatedGammaExposure3).reduce((max, strike) => {
        return calculatedGammaExposure3[strike] > calculatedGammaExposure3[max] ? strike : max;
      }, Object.keys(calculatedGammaExposure3)[0]);
      setLargestPositiveGammaStrike3(largestPositiveGammaStrike3);

      const largestNegativeGammaStrike3 = Object.keys(calculatedGammaExposure3).reduce((min, strike) => {
        return calculatedGammaExposure3[strike] < calculatedGammaExposure3[min] ? strike : min;
      }, Object.keys(calculatedGammaExposure3)[0]);
      setLargestNegativeGammaStrike3(largestNegativeGammaStrike3);

      const totalGammaExposure3 = Object.values(calculatedGammaExposure3).reduce((sum, value) => sum + value, 0);
      setTotalGammaExposure3(totalGammaExposure3);

      const calculatedGammaExposure4 = calculateGammaExposure(ndxData, ndxPrice, 250);
      setAdjustedGammaExposure4(calculatedGammaExposure4);

      const largestPositiveGammaStrike4 = Object.keys(calculatedGammaExposure4).reduce((max, strike) => {
        return calculatedGammaExposure4[strike] > calculatedGammaExposure4[max] ? strike : max;
      }, Object.keys(calculatedGammaExposure4)[0]);
      setLargestPositiveGammaStrike4(largestPositiveGammaStrike4);

      const largestNegativeGammaStrike4 = Object.keys(calculatedGammaExposure4).reduce((min, strike) => {
        return calculatedGammaExposure4[strike] < calculatedGammaExposure4[min] ? strike : min;
      }, Object.keys(calculatedGammaExposure4)[0]);
      setLargestNegativeGammaStrike4(largestNegativeGammaStrike4);

      const totalGammaExposure4 = Object.values(calculatedGammaExposure4).reduce((sum, value) => sum + value, 0);
      setTotalGammaExposure4(totalGammaExposure4);

      const strikes = Object.keys(calculatedGammaExposure).map(Number);
      const minStrike = Math.min(...strikes);
      const maxStrike = Math.max(...strikes);
      const newXAxisRange = [minStrike - .5, maxStrike + .5];
      const yAxisRange = calculateYAxisRange(calculatedGammaExposure);

      // Create initial layout
      const initialLayout = {
        title: `SPY<br>${spyPrice.toFixed(2)}`,
        
        xaxis: { 
          title: 'Strike',
          range: newXAxisRange,
          fixedrange: true
        },
        yaxis: { 
          title: 'SPY Gamma Exposure',
          range: yAxisRange,
          fixedrange: true
        },
        plot_bgcolor: '#222',
        paper_bgcolor: '#222',
        font: { color: 'white' },
        width: isMobile() ? Math.min(window.innerWidth * 0.9, 800) : 800,
        height: 500, // Set the height of the graph
        annotations: [
          {
            xref: 'paper',
            yref: 'paper',
            x: 0,
            xanchor: 'right',
            y: 1,
            yanchor: 'bottom',
            text: ` ${formattedTime}`,
            font: {
              family: 'Arial',
              size: 14,
              color: 'white',
            },
            showarrow: false,
          },
          {
            x: largestPositiveGammaStrike,
            y: calculatedGammaExposure[largestPositiveGammaStrike],
            xanchor: 'center',
            yanchor: 'bottom',
            text: `${largestPositiveGammaStrike}`,
            font: {
              family: 'Arial',
              size: 14,
              color: 'green',
            },
            showarrow: true,
            arrowhead: 1,
            ax: 0,
            ay: -30,
          },
          {
            x: largestNegativeGammaStrike,
            y: calculatedGammaExposure[largestNegativeGammaStrike],
            xanchor: 'center',
            yanchor: 'top',
            text: `${largestNegativeGammaStrike}`,
            font: {
              family: 'Arial',
              size: 14,
              color: 'red',
            },
            showarrow: true,
            arrowhead: 1,
            ax: 0,
            ay: 30,
          },
          {
            xref: 'paper',
            yref: 'paper',
            x: 1,
            xanchor: 'right',
            y: 1,
            yanchor: 'bottom',
            text: `Total: ${totalGammaExposure.toFixed(0)}M`,
            font: {
              family: 'Arial',
              size: 14,
              color: 'white',
            },
            showarrow: false,
          },
        ],
        shapes: [
          {
            type: 'circle',
            xref: 'x',
            yref: 'y',
            x0: parseFloat(largestPositiveGammaStrike) - calculateCircleSize(calculatedGammaExposure[largestPositiveGammaStrike]),
            y0: -Math.max(Math.abs(calculatedGammaExposure[largestPositiveGammaStrike]), Math.abs(calculatedGammaExposure[largestNegativeGammaStrike])),
            x1: parseFloat(largestPositiveGammaStrike) + calculateCircleSize(calculatedGammaExposure[largestPositiveGammaStrike]),
            y1: Math.max(Math.abs(calculatedGammaExposure[largestPositiveGammaStrike]), Math.abs(calculatedGammaExposure[largestNegativeGammaStrike])),
            fillcolor: 'green',
            opacity: 0.3,
            line: { color: 'green', width: 2 }
          },
          {
            type: 'circle',
            xref: 'x',
            yref: 'y',
            x0: parseFloat(largestNegativeGammaStrike) - calculateCircleSize(calculatedGammaExposure[largestNegativeGammaStrike]),
            y0: -Math.abs(calculatedGammaExposure[largestNegativeGammaStrike]),
            x1: parseFloat(largestNegativeGammaStrike) + calculateCircleSize(calculatedGammaExposure[largestNegativeGammaStrike]),
            y1: Math.abs(calculatedGammaExposure[largestNegativeGammaStrike]),
            fillcolor: 'red',
            opacity: 0.3,
            line: { color: 'red', width: 2 }
          },
          {
            type: 'line',
            xref: 'x',
            x0: spyPrice.toFixed(2),
            x1: spyPrice.toFixed(2),
            yref: 'paper',
            y0: 0,
            y1: 1,
            yanchor: 'bottom',
            line: {
              color: 'white',
              width: 2,
            },
          },
        ],

      };

      setLayout(initialLayout);

      const strikes2 = Object.keys(calculatedGammaExposure2).map(Number);
      const minStrike2 = Math.min(...strikes2);
      const maxStrike2 = Math.max(...strikes2);
      const newXAxisRange2 = [minStrike2 - .5, maxStrike2 + .5];
      const yAxisRange2 = calculateYAxisRange(calculatedGammaExposure2);

      const initialLayout2 = {
        title: `QQQ<br>${qqqPrice.toFixed(2)}`,
        xaxis: { 
          title: 'Strike',
          range: newXAxisRange2,
          fixedrange: true
        },
        yaxis: { 
          title: 'QQQ Gamma Exposure',
          range: yAxisRange2,
          fixedrange: true
        },
        plot_bgcolor: '#222',
        paper_bgcolor: '#222',
        font: { color: 'white' },
        width: isMobile() ? Math.min(window.innerWidth * 0.9, 800) : 800,
        height: 500, // Set the height of the graph
        annotations: [
          {
            xref: 'paper',
            yref: 'paper',
            x: 0,
            xanchor: 'right',
            y: 1,
            yanchor: 'bottom',
            text: ` ${dateString}`,
            font: {
              family: 'Arial',
              size: 14,
              color: 'white',
            },
            showarrow: false,
          },
          {
            x: largestPositiveGammaStrike2,
            y: calculatedGammaExposure2[largestPositiveGammaStrike2],
            xanchor: 'center',
            yanchor: 'bottom',
            text: `${largestPositiveGammaStrike2}`,
            font: {
              family: 'Arial',
              size: 14,
              color: 'green',
            },
            showarrow: true,
            arrowhead: 1,
            ax: 0,
            ay: -30,
          },
          {
            x: largestNegativeGammaStrike2,
            y: calculatedGammaExposure2[largestNegativeGammaStrike2],
            xanchor: 'center',
            yanchor: 'top',
            text: `${largestNegativeGammaStrike2}`,
            font: {
              family: 'Arial',
              size: 14,
              color: 'red',
            },
            showarrow: true,
            arrowhead: 1,
            ax: 0,
            ay: 30,
          },
          {
            xref: 'paper',
            yref: 'paper',
            x: 1,
            xanchor: 'right',
            y: 1,
            yanchor: 'bottom',
            text: `Total: ${totalGammaExposure2.toFixed(0)}M`,
            font: {
              family: 'Arial',
              size: 14,
              color: 'white',
            },
            showarrow: false,
          },
        ],
        shapes: [
          {
            type: 'circle',
            xref: 'x',
            yref: 'y',
            x0: parseFloat(largestPositiveGammaStrike2) - calculateCircleSize(calculatedGammaExposure2[largestPositiveGammaStrike2]),
            y0: -Math.max(Math.abs(calculatedGammaExposure2[largestPositiveGammaStrike2]), Math.abs(calculatedGammaExposure2[largestNegativeGammaStrike2])),
            x1: parseFloat(largestPositiveGammaStrike2) + calculateCircleSize(calculatedGammaExposure2[largestPositiveGammaStrike2]),
            y1: Math.max(Math.abs(calculatedGammaExposure2[largestPositiveGammaStrike2]), Math.abs(calculatedGammaExposure2[largestNegativeGammaStrike2])),
            fillcolor: 'green',
            opacity: 0.3,
            line: { color: 'green', width: 2 }
          },
          {
            type: 'circle',
            xref: 'x',
            yref: 'y',
            x0: parseFloat(largestNegativeGammaStrike2) - calculateCircleSize(calculatedGammaExposure2[largestNegativeGammaStrike2]),
            y0: -Math.abs(calculatedGammaExposure2[largestNegativeGammaStrike2]),
            x1: parseFloat(largestNegativeGammaStrike2) + calculateCircleSize(calculatedGammaExposure2[largestNegativeGammaStrike2]),
            y1: Math.abs(calculatedGammaExposure2[largestNegativeGammaStrike2]),
            fillcolor: 'red',
            opacity: 0.3,
            line: { color: 'red', width: 2 }
          },
          {
            type: 'line',
            xref: 'x',
            x0: qqqPrice.toFixed(2),
            x1: qqqPrice.toFixed(2),
            yref: 'paper',
            y0: 0,
            y1: 1,
            yanchor: 'bottom',
            line: {
              color: 'white',
              width: 2,
            },
          },
        ],
      };
      setLayout2(initialLayout2);

      const strikes3 = Object.keys(calculatedGammaExposure3).map(Number);
      const minStrike3 = Math.min(...strikes3);
      const maxStrike3 = Math.max(...strikes3);
      const newXAxisRange3 = [minStrike3 - 2.5, maxStrike3 + 2.5];
      const yAxisRange3 = calculateYAxisRange(calculatedGammaExposure3);
    
      const initialLayout3 = {
        title: `SPX<br>${spxPrice.toFixed(0)}`,
        xaxis: { 
          title: 'Strike',
          range: newXAxisRange3,
          fixedrange: true
        },
        yaxis: { 
          title: 'SPX Gamma Exposure',
          range: yAxisRange3,
          fixedrange: true
        },
        plot_bgcolor: '#222',
        paper_bgcolor: '#222',
        font: { color: 'white' },
        //width: 800, // Set the width of the graph
        width: isMobile() ? Math.min(window.innerWidth * 0.9, 800) : 800,
        height: 500, // Set the height of the graph
        annotations: [
          {
            xref: 'paper',
            yref: 'paper',
            x: 0,
            xanchor: 'right',
            y: 1,
            yanchor: 'bottom',
            text: ` ${""}`,
            font: {
              family: 'Arial',
              size: 14,
              color: 'white',
            },
            showarrow: false,
          },
          {
            x: largestPositiveGammaStrike3,
            y: calculatedGammaExposure3[largestPositiveGammaStrike3],
            xanchor: 'center',
            yanchor: 'bottom',
            text: `${largestPositiveGammaStrike3}`,
            font: {
              family: 'Arial',
              size: 14,
              color: 'green',
            },
            showarrow: true,
            arrowhead: 1,
            ax: 0,
            ay: -30,
          },
          {
            x: largestNegativeGammaStrike3,
            y: calculatedGammaExposure3[largestNegativeGammaStrike3],
            xanchor: 'center',
            yanchor: 'top',
            text: `${largestNegativeGammaStrike3}`,
            font: {
              family: 'Arial',
              size: 14,
              color: 'red',
            },
            showarrow: true,
            arrowhead: 1,
            ax: 0,
            ay: 30,
          },
          {
            xref: 'paper',
            yref: 'paper',
            x: 1,
            xanchor: 'right',
            y: 1,
            yanchor: 'bottom',
            text: `Total: ${totalGammaExposure3.toFixed(0)}M`,
            font: {
              family: 'Arial',
              size: 14,
              color: 'white',
            },
            showarrow: false,
          },
        ],
        shapes: [
          {
            type: 'circle',
            xref: 'x',
            yref: 'y',
            x0: parseFloat(largestPositiveGammaStrike3) - (5*calculateCircleSize(calculatedGammaExposure3[largestPositiveGammaStrike3])),
            y0: -Math.max(Math.abs(calculatedGammaExposure3[largestPositiveGammaStrike3]), Math.abs(calculatedGammaExposure3[largestNegativeGammaStrike3])),
            x1: parseFloat(largestPositiveGammaStrike3) + (5*calculateCircleSize(calculatedGammaExposure3[largestPositiveGammaStrike3])),
            y1: Math.max(Math.abs(calculatedGammaExposure3[largestPositiveGammaStrike3]), Math.abs(calculatedGammaExposure3[largestNegativeGammaStrike3])),
            fillcolor: 'green',
            opacity: 0.3,
            line: { color: 'green', width: 2 }
          },
          {
            type: 'circle',
            xref: 'x',
            yref: 'y',
            x0: parseFloat(largestNegativeGammaStrike3) - (5*calculateCircleSize(calculatedGammaExposure3[largestNegativeGammaStrike3])),
            y0: -Math.abs(calculatedGammaExposure3[largestNegativeGammaStrike3]),
            x1: parseFloat(largestNegativeGammaStrike3) + (5*calculateCircleSize(calculatedGammaExposure3[largestNegativeGammaStrike3])),
            y1: Math.abs(calculatedGammaExposure3[largestNegativeGammaStrike3]),
            fillcolor: 'red',
            opacity: 0.3,
            line: { color: 'red', width: 2 }
          },
          {
            type: 'line',
            xref: 'x',
            x0: spxPrice.toFixed(0),
            x1: spxPrice.toFixed(0),
            yref: 'paper',
            y0: 0,
            y1: 1,
            yanchor: 'bottom',
            line: {
              color: 'white',
              width: 2,
            },
          },
        ],
      };
      setLayout3(initialLayout3);

      const strikes4 = Object.keys(calculatedGammaExposure4).map(Number);
      const minStrike4 = Math.min(...strikes4);
      const maxStrike4 = Math.max(...strikes4);
      const newXAxisRange4 = [minStrike4 -10, maxStrike4 + 10];
      const yAxisRange4 = calculateYAxisRange(calculatedGammaExposure4);
    
      const initialLayout4 = {
        title: `NDX<br>${ndxPrice.toFixed(0)}`,
        xaxis: { 
          title: 'Strike',
          range: newXAxisRange4,
          fixedrange: true
        },
        yaxis: { 
          title: 'NDX Gamma Exposure',
          range: yAxisRange4,
          fixedrange: true
        },
        plot_bgcolor: '#222',
        paper_bgcolor: '#222',
        font: { color: 'white' },
        width: isMobile() ? Math.min(window.innerWidth * 0.9, 800) : 800,
        height: 500, // Set the height of the graph
        annotations: [
          {
            xref: 'paper',
            yref: 'paper',
            x: 0,
            xanchor: 'right',
            y: 1,
            yanchor: 'bottom',
            text: ` ${""}`,
            font: {
              family: 'Arial',
              size: 14,
              color: 'white',
            },
            showarrow: false,
          },
          {
            x: largestPositiveGammaStrike4,
            y: calculatedGammaExposure4[largestPositiveGammaStrike4],
            xanchor: 'center',
            yanchor: 'bottom',
            text: `${largestPositiveGammaStrike4}`,
            font: {
              family: 'Arial',
              size: 14,
              color: 'green',
            },
            showarrow: true,
            arrowhead: 1,
            ax: 0,
            ay: -30,
          },
          {
            x: largestNegativeGammaStrike4,
            y: calculatedGammaExposure4[largestNegativeGammaStrike4],
            xanchor: 'center',
            yanchor: 'top',
            text: `${largestNegativeGammaStrike4}`,
            font: {
              family: 'Arial',
              size: 14,
              color: 'red',
            },
            showarrow: true,
            arrowhead: 1,
            ax: 0,
            ay: 30,
          },
          {
            xref: 'paper',
            yref: 'paper',
            x: 1,
            xanchor: 'right',
            y: 1,
            yanchor: 'bottom',
            text: `Total: ${totalGammaExposure4.toFixed(0)}M`,
            font: {
              family: 'Arial',
              size: 14,
              color: 'white',
            },
            showarrow: false,
          },
        ],
        shapes: [
          {
            type: 'circle',
            xref: 'x',
            yref: 'y',
            x0: parseFloat(largestPositiveGammaStrike4) - (20*calculateCircleSize(calculatedGammaExposure4[largestPositiveGammaStrike4])),
            y0: -Math.max(Math.abs(calculatedGammaExposure4[largestPositiveGammaStrike4]), Math.abs(calculatedGammaExposure4[largestNegativeGammaStrike4])),
            x1: parseFloat(largestPositiveGammaStrike4) + (20*calculateCircleSize(calculatedGammaExposure4[largestPositiveGammaStrike4])),
            y1: Math.max(Math.abs(calculatedGammaExposure4[largestPositiveGammaStrike4]), Math.abs(calculatedGammaExposure4[largestNegativeGammaStrike4])),
            fillcolor: 'green',
            opacity: 0.3,
            line: { color: 'green', width: 2 }
          },
          {
            type: 'circle',
            xref: 'x',
            yref: 'y',
            x0: parseFloat(largestNegativeGammaStrike4) - (20*calculateCircleSize(calculatedGammaExposure4[largestNegativeGammaStrike4])),
            y0: -Math.abs(calculatedGammaExposure4[largestNegativeGammaStrike4]),
            x1: parseFloat(largestNegativeGammaStrike4) + (20*calculateCircleSize(calculatedGammaExposure4[largestNegativeGammaStrike4])),
            y1: Math.abs(calculatedGammaExposure4[largestNegativeGammaStrike4]),
            fillcolor: 'red',
            opacity: 0.3,
            line: { color: 'red', width: 2 }
          },
          {
            type: 'line',
            xref: 'x',
            x0: ndxPrice.toFixed(0),
            x1: ndxPrice.toFixed(0),
            yref: 'paper',
            y0: 0,
            y1: 1,
            yanchor: 'bottom',
            line: {
              color: 'white',
              width: 2,
            },
          },
        ],
      };
      setLayout4(initialLayout4);
    
    };
    getData();
    
  }, []);
  
  const sliderMarks = {};
  for (let i =  - 5; i <= 5; i += 1) {
    sliderMarks[i] = {
      label: i.toFixed(0),
      style: {
        fontSize: '16px', // Set the font size here
        color: 'white', // Set the font color here
        marginTop: 5,
      },
    };
  }

  function isMobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  }

  const deviceWidth = isMobile() ? '90vw' : '800px';

  const slider = (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: deviceWidth, 
        margin: '0 auto',
      }}>
      <Slider
        min={-5}
        max={5}
        value={sliderChange}
        step={0.5}
        onChange={handleSliderChange}
        trackStyle={{
          backgroundColor:  '#3a3a3a',
          height: 6,
          width: '100%',
        }}
        handleStyle={{
          borderColor: 'black',
          borderWidth: 1,
          height: 35,
          width: 35,
          marginLeft: 0,
          marginTop: -15,
          backgroundColor: 'black',
          opacity: 1,
        }}
        railStyle={{
          backgroundColor: '#3a3a3a',
          height: 6,
        }}
        dotStyle={{
          width: '20px',
          height: '20px',
          borderRadius: '50%',
          backgroundColor: 'white',
          border: 'none',
          bottom: '-10px',
          
        }}
        dot={(
          <div
            className="slider-dot"
            style={{
              width: '20px',
              height: '20px',
              borderRadius: '50%',
              backgroundColor: 'white',
              border: 'none',
              bottom: '-10px',
            }}
          />
        )}
        marks={sliderMarks}
      />
    </div>
  );
  
  const graphData = [
    {
      x: Object.keys(adjustedGammaExposure),
      y: Object.values(adjustedGammaExposure),
      type: 'bar',
      marker: {
        color: Object.values(adjustedGammaExposure).map((value) =>
          value >= 0 ? 'green' : 'red'
        ),
      },
    },
  ];

  const graphData2 = [
    {
      x: Object.keys(adjustedGammaExposure2),
      y: Object.values(adjustedGammaExposure2),
      type: 'bar',
      marker: {
        color: Object.values(adjustedGammaExposure2).map((value) =>
          value >= 0 ? 'green' : 'red'
        ),
      },
    },
  ];

  const graphData3 = [
    {
      x: Object.keys(adjustedGammaExposure3),
      y: Object.values(adjustedGammaExposure3),
      type: 'bar',
      marker: {
        color: Object.values(adjustedGammaExposure3).map((value) =>
          value >= 0 ? 'green' : 'red'
        ),
      },
    },
  ];

  const graphData4 = [
    {
      x: Object.keys(adjustedGammaExposure4),
      y: Object.values(adjustedGammaExposure4),
      type: 'bar',
      marker: {
        color: Object.values(adjustedGammaExposure4).map((value) =>
          value >= 0 ? 'green' : 'red'
        ),
      },
    },
  ];

  

  

  const graph = <Plot data={graphData} layout={layout} />;
  const graph2 = <Plot data={graphData2} layout={layout2} />;
  const graph3 = <Plot data={graphData3} layout={layout3} />;
  const graph4 = <Plot data={graphData4} layout={layout4} />;

  return (
    <div className="App">
      <header className="App-header">
        <h1>Gamma Dashboard</h1>
        {slider}
      </header>
      <div className="App-body">
        {graph}
        {graph2}
        {graph3}
        {graph4}
      </div>
      <Footer />
    </div>
  );
};

export default App;